
import { useEffect, useRef, useState } from 'react';
import { useFormik } from 'formik';
import { Toast } from 'primereact/toast';
import { PMTemplatePerformancePoint } from '../../services/Template/pm-template-performance-point';
import { Api } from '../../services/api';
import { Chart } from 'primereact/chart';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Chart as ChartJS, Tooltip, Legend, ArcElement, Title, CategoryScale, LinearScale } from 'chart.js';
import './Main Dashboard.css'


// Register necessary chartjs components including the datalabels plugin
ChartJS.register(ArcElement, Tooltip, Legend, Title, CategoryScale, LinearScale, ChartDataLabels);

const MainDashboard = () => {

    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [billableTime, setBillableTime] = useState([]);
    const [payPeriods, setPayPeriods] = useState([]);
    const [annualDeliverables, setAnnualDeliverables] = useState({ "revenue": { "q1": 0, "q2": 0, "q3": 0, "q4": 0, "total": 0 }, "actuals": { "q1": 0, "q2": 0, "q3": 0, "q4": 0, "total": 0 }, "variance": { "q1": 0, "q2": 0, "q3": 0, "q4": 0, "total": 0 } });
    const [projectionAndAcutal, setProjectionAndAcutal] = useState([]);
    
    const [selectedRow, setSelectedRow] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    // --------------------------------------------------------------------

    const [dataForPer, setDataForPer] = useState(115);

    const [userName, setUserName] = useState("");
    const toast = useRef(null);
    const [roleID, setroleID] = useState('');

    //? --------------------------------------------------------------------

    const [projectManager, setProjectManager] = useState('');
    const [ProjectData, setProjectData] = useState([]);

    const [isShow, setIsShow] = useState(false);
    const columns = [
        { key: 'targetGp', label: 'ID' },
        { key: 'percentageCompletion', label: 'Name' },
        { key: 'costPerSF', label: 'Age' },

    ];
    const [tableColumns, setTableColumns] = useState(columns);
    const [tableColumnsForMonthly, setTableColumnsForMonthly] = useState(columns);
    const [monthlyClientRating, setMonthlyClientRating] = useState([]);

    const [coreValues, setCoreValues] = useState([]);
    const [purpose, setPurpose] = useState([]);

    //* --------------------------------------------------------------------
    const [chartData, setChartData] = useState({});
    const [chartOptions, setChartOptions] = useState({});

    const [ltTeamChartData, setLtTeamChartData] = useState({});
    const [projectionsChartData, setProjectionsChartData] = useState({});
    const [varianceChartData2, setVarianceChartData2] = useState({});
    //! --------------------------------------------------------------------

    //* --------------------------------------------------------------------
    const [myFinancialTargetsChartData, setMyFinancialTargetsChartData] = useState({});
    const [revenueChartData, setRevenueChartData] = useState({});
    const [projectionChartData, setProjectionChartData] = useState({});
    const [varianceChartData, setVarianceChartData] = useState({});
    //! --------------------------------------------------------------------

    //* --------------------------------------------------------------------
    const [barChartData, setBarChartData] = useState({}); // State for bar chart data
    const [barChartOptions, setBarChartOptions] = useState({}); // State for bar chart options

    //* --------------------------------------------------------------------
    const [revenue1ChartOptions, setRevenue1ChartOptions] = useState({});
    const [projection1ChartOptions, setProjection1ChartOptions] = useState({});
    const [variance1ChartOptions, setVariance1ChartOptions] = useState({});
    const [ltTeamChartOptions, setLtTeamChartOptions] = useState({});
    const [projectionsChartOptions, setProjectionsChartOptions] = useState({});
    const [varianceChartOptions, setVarianceChartOptions] = useState({});
    //! --------------------------------------------------------------------

    const formik = useFormik({
        initialValues: PMTemplatePerformancePoint.getFormName(),
        validate: (data) => {
        },

        onSubmit: (data) => {

        }
    });


    //! -----------------------
    const headerStyle = {
        border: "1px solid #E9ECEF",
        textAlign: "center",
        fontSize: "14px",
    };

    const cellStyle = {
        borderLeft: "2px solid #E9ECEF",
        textAlign: "center",
        fontSize: "14px",
        border: '1px solid white',
        backgroundColor: 'white'
    };
    const cellStyleT = {
        borderLeft: "2px solid #E9ECEF",
        textAlign: "center",
        fontSize: "14px",
        border: '1px solid white',
        backgroundColor: 'white',
        padding: '8px'
    };

    const cellStyleW = {
        borderLeft: "2px solid #E9ECEF",
        textAlign: "center",
        fontSize: "14px",
        border: '1px solid white',
    };


    //* --------------------------------------

    const prepareMyFinancialTargetsChartData = () => {
        // Calculate total revenue to use for percentage calculation
        const totalRevenue = annualDeliverables.revenue.total;

        // Revenue chart data - Calculate percentages and round to 2 decimal places
        const revenueData = [
            ((annualDeliverables.revenue.q1 / totalRevenue) * 100).toFixed(2),
            ((annualDeliverables.revenue.q2 / totalRevenue) * 100).toFixed(2),
            ((annualDeliverables.revenue.q3 / totalRevenue) * 100).toFixed(2),
            ((annualDeliverables.revenue.q4 / totalRevenue) * 100).toFixed(2),
        ];
        const revenueChart = {
            labels: ['Q1', 'Q2', 'Q3', 'Q4'],
            datasets: [
                {
                    data: revenueData,
                    backgroundColor: ['#42A5F5', '#66BB6A', '#FFA726', '#FF7043'],
                    hoverBackgroundColor: ['#64B5F6', '#81C784', '#FFB74D', '#FFAB91'],
                },
            ],
        };


        setRevenueChartData(revenueChart);
        setRevenue1ChartOptions({
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    position: 'top', // Change this to your desired position
                    labels: {
                        boxWidth: 20,
                        color: 'black', // Set the color of the legend text
                    }
                },
                tooltip: {
                    callbacks: {
                        label: (tooltipItem) => {
                            const label = tooltipItem.label || '';
                            const value = tooltipItem.raw || 0;
                            return `${label}: ${value}%`; // Format: Label: Value (Percentage%)
                        }
                    }
                },
                datalabels: {
                    color: 'white',
                    formatter: (value) => value + '%',
                    anchor: 'center',
                    align: 'center'
                }
            }
        });


        const totalActuals = annualDeliverables.actuals.total;

        const projectionData = [
            ((annualDeliverables.actuals.q1 / totalActuals) * 100).toFixed(2),
            ((annualDeliverables.actuals.q2 / totalActuals) * 100).toFixed(2),
            ((annualDeliverables.actuals.q3 / totalActuals) * 100).toFixed(2),
            ((annualDeliverables.actuals.q4 / totalActuals) * 100).toFixed(2),
        ];
        const projectionChart = {
            labels: ['Q1', 'Q2', 'Q3', 'Q4'],
            datasets: [
                {
                    data: projectionData,
                    backgroundColor: ['#42A5F5', '#66BB6A', '#FFA726', '#FF7043'],
                    hoverBackgroundColor: ['#64B5F6', '#81C784', '#FFB74D', '#FFAB91'],
                },
            ],
        };
        setProjectionChartData(projectionChart);
        setProjection1ChartOptions({
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    position: 'top', // Change this to your desired position
                    labels: {
                        boxWidth: 20,
                        color: 'black', // Set the color of the legend text
                    }
                },
                tooltip: {
                    callbacks: {
                        label: (tooltipItem) => {
                            const label = tooltipItem.label || '';
                            const value = tooltipItem.raw || 0;
                            return `${label}: ${value}%`; // Format: Label: Value (Percentage%)
                        }
                    }
                },
                datalabels: {
                    color: 'white',
                    formatter: (value) => value + '%',
                    anchor: 'center',
                    align: 'center'
                }
            }
        });



        // Calculate total variance to use for percentage calculation
        const totalVariance = annualDeliverables.variance.total;

        // Yearly/Quarterly Variance chart data - Calculate percentages and round to 2 decimal places
        const varianceData = [
            ((annualDeliverables.variance.q1 / totalVariance) * 100).toFixed(2),
            ((annualDeliverables.variance.q2 / totalVariance) * 100).toFixed(2),
            ((annualDeliverables.variance.q3 / totalVariance) * 100).toFixed(2),
            ((annualDeliverables.variance.q4 / totalVariance) * 100).toFixed(2),
        ];
        const varianceChart = {
            labels: ['Q1', 'Q2', 'Q3', 'Q4'],
            datasets: [
                {
                    data: varianceData,
                    backgroundColor: ['#42A5F5', '#66BB6A', '#FFA726', '#FF7043'],
                    hoverBackgroundColor: ['#64B5F6', '#81C784', '#FFB74D', '#FFAB91'],
                },
            ],
        };
        setVarianceChartData(varianceChart);
        setVariance1ChartOptions({
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    position: 'top', // Change this to your desired position
                    labels: {
                        boxWidth: 20,
                        color: 'black', // Set the color of the legend text
                    }
                },
                tooltip: {
                    callbacks: {
                        label: (tooltipItem) => {
                            const label = tooltipItem.label || '';
                            const value = tooltipItem.raw || 0;
                            return `${label}: ${value}%`; // Format: Label: Value (Percentage%)
                        }
                    }
                },
                datalabels: {
                    color: 'white',
                    formatter: (value) => value + '%',
                    anchor: 'center',
                    align: 'center'
                }
            }
        });
    };
    //! ---------------------------------------


    //* -------------- Chart - Companies Financial Target For The Year ------------------------

    const prepareChartData = () => {
        // Extract yearly totals for percentage calculations
        const yearlyData = projectionAndAcutal.find(item => item.Quarter === 'Year');
        const yearlyLtTeam = yearlyData ? yearlyData.ltTeam : 1; // Avoid division by zero
        const yearlyProjection = yearlyData ? yearlyData.projection : 1; // Avoid division by zero
        const yearlyYearly = yearlyData ? yearlyData.yearly : 1; // Avoid division by zero

        // Filter out the "Year" row for chart data
        const filteredData = projectionAndAcutal.filter(item => item.Quarter !== 'Year');

        // Calculate percentages
        const ltTeamPercentages = filteredData.map(item => ((item.ltTeam / yearlyLtTeam) * 100).toFixed(2));
        const projectionsPercentages = filteredData.map(item => ((item.projection / yearlyProjection) * 100).toFixed(2));
        const variancePercentages = filteredData.map(item => ((item.yearly / yearlyYearly) * 100).toFixed(2));

        console.log('variancePercentages----------->>>', variancePercentages)

        // Chart data for Lt Team
        const chartData = {
            labels: ['Q1', 'Q2', 'Q3', 'Q4'],
            datasets: [
                {
                    data: ltTeamPercentages,
                    backgroundColor: ['#42A5F5', '#66BB6A', '#FFA726', '#FF7043'],
                    hoverBackgroundColor: ['#64B5F6', '#81C784', '#FFB74D', '#FFAB91']
                }
            ]
        };
        setLtTeamChartData(chartData);
        setLtTeamChartOptions({
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    position: 'top', // Change this to your desired position
                    labels: {
                        boxWidth: 20,
                        color: 'black', // Set the color of the legend text
                    }
                },
                tooltip: {
                    callbacks: {
                        label: (tooltipItem) => {
                            const label = tooltipItem.label || '';
                            const value = tooltipItem.raw || 0;
                            return `${label}: ${value}%`; // Format: Label: Value (Percentage%)
                        }
                    }
                },
                datalabels: {
                    color: 'white',
                    formatter: (value) => value + '%',
                    anchor: 'center',
                    align: 'center'
                }
            }
        });

        // Chart data for Projections
        const projectionsChart = {
            labels: ['Q1', 'Q2', 'Q3', 'Q4'],
            datasets: [
                {
                    data: projectionsPercentages,
                    backgroundColor: ['#42A5F5', '#66BB6A', '#FFA726', '#FF7043'],
                    hoverBackgroundColor: ['#64B5F6', '#81C784', '#FFB74D', '#FFAB91']
                }
            ]
        };
        setProjectionsChartData(projectionsChart);
        setProjectionsChartOptions({
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    position: 'top', // Change this to your desired position
                    labels: {
                        boxWidth: 20,
                        color: 'black', // Set the color of the legend text
                    }
                },
                tooltip: {
                    callbacks: {
                        label: (tooltipItem) => {
                            const label = tooltipItem.label || '';
                            const value = tooltipItem.raw || 0;
                            return `${label}: ${value}%`; // Format: Label: Value (Percentage%)
                        }
                    }
                },
                datalabels: {
                    color: 'white',
                    formatter: (value) => value + '%',
                    anchor: 'center',
                    align: 'center'
                }
            }
        });

        // Chart data for Variance
        const varianceChart = {
            labels: ['Q1', 'Q2', 'Q3', 'Q4'],
            datasets: [
                {
                    data: variancePercentages,
                    backgroundColor: ['#42A5F5', '#66BB6A', '#FFA726', '#FF7043'],
                    hoverBackgroundColor: ['#64B5F6', '#81C784', '#FFB74D', '#FFAB91']
                }
            ]
        };
        setVarianceChartData2(varianceChart);
        setVarianceChartOptions({
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    position: 'top', // Change this to your desired position
                    labels: {
                        boxWidth: 20,
                        color: 'black', // Set the color of the legend text
                    }
                },
                tooltip: {
                    callbacks: {
                        label: (tooltipItem) => {
                            const label = tooltipItem.label || '';
                            const value = tooltipItem.raw || 0;
                            return `${label}: ${value}%`; // Format: Label: Value (Percentage%)
                        }
                    }
                },
                datalabels: {
                    color: 'white',
                    formatter: (value) => value + '%',
                    anchor: 'center',
                    align: 'center'
                }
            }
        });
    };

    //! ------------- Chart - Companies Financial Target For The Year -------------------------

    //* ---------------------------------------
    const prepareBarChartData = () => {
        // Assuming monthlyClientRating is an array of objects
        const monthlyRatings = monthlyClientRating
            .filter(row => row['rowKey_0'] !== 'Total' && row['rowKey_0'] !== 'MONTHLY CLIENT RATING') // Exclude 'Total' entries
            .map(row => ({
                month: row['rowKey_0'], // Month name
                monthlyClientRating: row['rowKey_1'], // Monthly Client Rating
                overallRating: row['rowKey_2'] // Overall Rating
            }));

        // console.log('monthlyRatings------------>', monthlyClientRating)

        const labels = monthlyRatings.map(item => item.month); // Extract month names for x-axis
        const clientRatings = monthlyRatings.map(item => item.monthlyClientRating);
        const overallRatings = monthlyRatings.map(item => item.overallRating);

        // Create a color array for the bars
        const clientRatingColors = clientRatings.map(item => item === 'Total' ? '#FF6384' : '#42A5F5');

        const data = {
            labels: labels,
            datasets: [
                {
                    label: '',
                    backgroundColor: clientRatingColors,
                    data: clientRatings
                },

            ]
        };

        setBarChartData(data);
        setBarChartOptions({
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                datalabels: {
                    color: 'white',
                    anchor: 'center',
                    align: 'center',
                    formatter: (value) => value,
                    font: {
                        weight: 'bold',
                        size: 12
                    }
                },
                legend: {
                    display: false
                },
                tooltip: {
                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                    titleColor: '#2c3e50',
                    bodyColor: '#2c3e50',
                    borderColor: '#e9ecef',
                    borderWidth: 1,
                    padding: 10,
                    cornerRadius: 8,
                    displayColors: false,
                    callbacks: {
                        label: function(context) {
                            return `Rating: ${context.parsed.y}`;
                        }
                    }
                }
            },
            scales: {
                y: {
                    beginAtZero: true,
                    max: 10,
                    title: {
                        display: true,
                        text: 'Overall Rating',
                        font: {
                            size: 14,
                            weight: 'bold',
                            family: "'Inter', sans-serif"
                        },
                        color: '#4a5568'
                    },
                    grid: {
                        display: true,
                        color: '#f0f2f5',
                        borderDash: [5, 5]
                    },
                    ticks: {
                        font: {
                            family: "'Inter', sans-serif"
                        },
                        color: '#718096'
                    },
                    border: {
                        display: false
                    }
                },
                x: {
                    title: {
                        display: true,
                        text: 'Months',
                        font: {
                            size: 14,
                            weight: 'bold',
                            family: "'Inter', sans-serif"
                        },
                        color: '#4a5568'
                    },
                    grid: {
                        display: false
                    },
                    ticks: {
                        font: {
                            family: "'Inter', sans-serif",
                            weight: '500'
                        },
                        color: '#718096'
                    },
                    border: {
                        display: false
                    }
                }
            },
            elements: {
                bar: {
                    borderRadius: 6,
                    borderSkipped: false
                }
            }
        });
    };

    //! ---------------------------------------

    useEffect(() => {

        var roleID = localStorage.getItem('role_id');
        setroleID(roleID)
        if (roleID == 18) {
            setDataForPer(50)
        }
        var name = localStorage.getItem('name');
        setUserName(name);


        var user_id = localStorage.getItem('user_id');
        var role_id = localStorage.getItem('role_id');

        performancePoints(user_id, role_id, selectedYear);

        return () => {
            // Cleanup tasks before the component is unmounted
        };
    }, []);

    useEffect(() => {
        if (projectionAndAcutal.length > 0) {
            prepareChartData();
        }
    }, [projectionAndAcutal]);

    useEffect(() => {
        if (annualDeliverables) {
            prepareMyFinancialTargetsChartData();
        }
    }, [annualDeliverables]);

    useEffect(() => {
        if (monthlyClientRating.length > 0) {
            prepareBarChartData();
        }
    }, [monthlyClientRating]);

    const performancePoints = (user_id, role_id, year = new Date().getFullYear()) => {
        const token = localStorage.getItem('authToken');

        // Create headers with token if it exists
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': token ? `Bearer ${token}` : '',
            'Cache-Control': 'no-cache'
        };


        var _body = {
            userId: user_id,
            role_id: role_id,
            year: year 
        }
        fetch(Api.API_BASE_URL + 'performance-dashbaord/dashbaord', {
            method: "POST",
            body: JSON.stringify(_body),
            headers: headers
        })
            .then((response) => response.json())
            .then((response) => {
                setIsLoading(false);

                setCoreValues(response.core_values);
                setPurpose(response.purpose);

                setProjectionAndAcutal(response.company_financial_targets_for_the_year);
                if (response.billableTime) {
                    setBillableTime(response.billableTime);
                    setPayPeriods(response.payPeriods);
                }

                if (response.my_financial_targets_for_the_year) {
                    setAnnualDeliverables(response.my_financial_targets_for_the_year);
                }

                FetchChartData(response.company_financial_targets_for_the_year);
                setProjectData(response.project_perofmance);
                setProjectManager(response.pM);

                setIsShow(response.isShow);


                var t = [];
                var r = [];


                for (let index = 0; index <= response.countAllResult; index++) {
                    t.push(index)
                    r.push(index)

                }
                setTableColumns(t);
                r.push('d')
                // setTableColumnsForMonthly(r);

                var s = [];

                for (let index = 0; index <= response.countAllResultForMotnlyCilentRatingAndActuals; index++) {
                    s.push(index)

                }
                s.push('d')
                setTableColumnsForMonthly(s);

                setMonthlyClientRating(response.my_client_rating);




            })
            .catch((error) => {
                setIsLoading(false);
                console.error("Error:", error);
            });
    }

    const FetchChartData = (result) => {
        console.log('result', result)
        const documentStyle = getComputedStyle(document.documentElement);
        const textColor = documentStyle.getPropertyValue('--text-color');
        const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
        const surfaceBorder = documentStyle.getPropertyValue('--surface-border');
        var ltTeam = [];
        var projection = [];
        var yearly = [];
        for (let index = 0; index < result.length; index++) {
            if (result[index].Quarter != 'Year') {
                const element = result[index];
                ltTeam.push(element.ltTeam);
                projection.push(element.projection);
                yearly.push(element.yearly);
            }
        }
        const data = {
            labels: ['Q1', 'Q2', 'Q3', 'Q4'],
            datasets: [
                {
                    label: 'LT TEAM 2023 ROCK',
                    backgroundColor: documentStyle.getPropertyValue('--blue-500'),
                    borderColor: documentStyle.getPropertyValue('--blue-500'),
                    data: ltTeam
                },
                {
                    label: 'PROJECTIONS & ACTUALS',
                    backgroundColor: documentStyle.getPropertyValue('--pink-500'),
                    borderColor: documentStyle.getPropertyValue('--pink-500'),
                    data: projection
                },
                {
                    label: 'YEARLY/QUARTERLY VARIANCE',
                    backgroundColor: documentStyle.getPropertyValue('--yellow-500'),
                    borderColor: documentStyle.getPropertyValue('--yellow-500'),
                    data: yearly
                }
            ]
        };
        const options = {
            maintainAspectRatio: false,
            aspectRatio: 0.8,
            plugins: {
                legend: {
                    labels: {
                        fontColor: textColor
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: textColorSecondary,
                        font: {
                            weight: 500
                        }
                    },
                    grid: {
                        display: false,
                        drawBorder: false
                    }
                },
                y: {
                    ticks: {
                        color: textColorSecondary
                    },
                    grid: {
                        color: surfaceBorder,
                        drawBorder: false
                    }
                }
            }
        };

        setChartData(data);
        setChartOptions(options);
    }


    const priceBodyTemplatee = (rowData) => {
        if (rowData === '') {
            return '';
        }
        let numberValue = Number(rowData);
        // Ensure rowData is a number after the conversion and it's not NaN
        if (isNaN(numberValue)) {

            return '';
        }

        const isNegative = rowData < 0;

        return (
            <span style={{ color: isNegative ? "red" : "black" }}>
                {formatCurrency(rowData)}
            </span>
        );
    };

    const formatCurrency = (value) => {
        return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    };
    // --------------------------------------------------------------------

    const formatValue = (value) => {
        return value == 0 ? '' : value;
    }

    const formatDate = (dateString) => {
        if (!dateString) return ''; // Return empty string if dateString is falsy
        const date = new Date(dateString);
        return date.toLocaleDateString(); // Format the date as needed
    };


    return (
        <div className="dashboard-container">
            <Toast ref={toast} />
            <form onSubmit={formik.handleSubmit} >

                <div style={{ minHeight: '88vh', margin: 0 }} >

                    {isLoading ? (
                        <div className="loading-spinner">
                            Loading...
                            <div className="spinner"></div>
                        </div>
                    ) : (


                        <div className="">

                            <div className='responsive-flex'>
                                {/* //*-----------1. My Financial Targets For The Year--------------------------- */}
                                <div className='dashboard-card dashboard-main-card'>
                                    <div className='dashboard-section-title'>
                                        <span>My Financial Targets For The Year</span>
                                    </div>
                                    <div className="flex-col">
                                        <div className='table-responsive'>
                                            <table className="dashboard-table compact-table" style={{ tableLayout: 'fixed' }}>
                                                <thead>
                                                    <tr>
                                                        <th>
                                                            <strong>Total</strong>
                                                        </th>
                                                        <th>
                                                            <strong>{priceBodyTemplatee(annualDeliverables.revenue.total)}</strong>
                                                        </th>
                                                        <th>
                                                            <strong>{priceBodyTemplatee(annualDeliverables.actuals.total)}</strong>
                                                        </th>
                                                        <th>
                                                            <strong>{priceBodyTemplatee(annualDeliverables.variance.total)}</strong>
                                                        </th>
                                                    </tr>
                                                </thead>
                                            </table>
                                        </div>

                                        <div className='pt-2 table-responsive'>
                                            <table className="dashboard-table compact-table" style={{ tableLayout: 'fixed' }}>
                                                <thead>
                                                    <tr>
                                                        <th>
                                                            <span>Quarter</span>
                                                        </th>
                                                        <th>
                                                            <span>Revenue</span>
                                                        </th>
                                                        <th>
                                                            <span>Projections & Actuals</span>
                                                        </th>
                                                        <th>
                                                            <span>Yearly/Quarterly Variance</span>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {['Q1', 'Q2', 'Q3', 'Q4'].map((quarter, index) => (
                                                        <tr key={index}>
                                                            <td>{quarter}</td>
                                                            <td>
                                                                {priceBodyTemplatee(annualDeliverables.revenue[`q${index + 1}`])}
                                                            </td>
                                                            <td>
                                                                {priceBodyTemplatee(annualDeliverables.actuals[`q${index + 1}`])}
                                                            </td>
                                                            <td>
                                                                {priceBodyTemplatee(annualDeliverables.variance[`q${index + 1}`])}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                {/* //!-------------------------------------- */}
                                {/* //*-----------2. COMPANIES FINANCIAL TARGETS FOR THE YEAR--------------------------- */}
                                <div className='dashboard-card dashboard-main-card'>
                                    <div className='dashboard-section-title'>
                                        <span>Companies Financial Target For The Year</span>
                                    </div>
                                    <div className="flex-col">
                                        <div className='table-responsive'>
                                            <table className="dashboard-table compact-table" style={{ width: '100%', tableLayout: 'fixed' }}>
                                                <thead>
                                                    <tr>
                                                        <th>
                                                            <strong>Total</strong>
                                                        </th>
                                                        <th>
                                                            <strong>{priceBodyTemplatee(projectionAndAcutal.find(item => item.Quarter === 'Year')?.ltTeam || '')}</strong>
                                                        </th>
                                                        <th>
                                                            <strong>{priceBodyTemplatee(projectionAndAcutal.find(item => item.Quarter === 'Year')?.projection || '')}</strong>
                                                        </th>
                                                        <th>
                                                            <strong>{priceBodyTemplatee(projectionAndAcutal.find(item => item.Quarter === 'Year')?.yearly || '')}</strong>
                                                        </th>
                                                    </tr>
                                                </thead>
                                            </table>
                                        </div>

                                        <div className='pt-2 table-responsive'>
                                            <table className="dashboard-table compact-table" style={{ width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed' }}>
                                                <thead>
                                                    <tr>
                                                        <th>
                                                            <span>Quarter</span>
                                                        </th>
                                                        <th>
                                                            <span>Lt Team {new Date().getFullYear()} Rock</span>
                                                        </th>
                                                        <th>
                                                            <span>Projection</span>
                                                        </th>
                                                        <th>
                                                            <span>Yearly/Quarterly Variance</span>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {projectionAndAcutal
                                                        .filter(item => item.Quarter !== 'Year')
                                                        .map((item, index) => (
                                                            <tr key={index}>
                                                                <td>{item.Quarter}</td>
                                                                <td>{priceBodyTemplatee(item.ltTeam)}</td>
                                                                <td>{priceBodyTemplatee(item.projection)}</td>
                                                                <td>{priceBodyTemplatee(item.yearly)}</td>
                                                            </tr>
                                                        ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                {/* //!-------------------------------------- */}
                            </div>

                            {/* //!------------------------------------ */}

                            {/* Comments */}
                            <div className='dashboard-card'>
                                <div className='dashboard-section-title' >
                                    <span>Comments:</span>
                                </div>
                                <div className='table-responsive'>
                                    <table className="dashboard-table compact-table">
                                        <tbody>
                                            {projectionAndAcutal
                                                .filter(item => item.vpComments?.trim()) // Exclude rows with empty or whitespace-only comments
                                                .map((item, index) => (
                                                    <tr key={index}>
                                                        <td style={{ textAlign: 'left' }}>
                                                            {item.vpComments}
                                                        </td>
                                                    </tr>
                                                ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            {/* //*-----------0. MY BILLABLE VS UNBILLABLE TIME--------------------------- */}
                            <div className='dashboard-card'>                                
                                <div header="MY BILLABLE VS UNBILLABLE TIME">
                                    <div className='dashboard-section-title' style={{ textAlign: 'center', justifyContent: 'center' }}>
                                        <span>My Billable Vs Unbillable Time</span>
                                    </div>

                                    <div className="table-responsive">
                                        <table className="dashboard-table compact-table" style={{ tableLayout: "fixed" }}>
                                            <thead>
                                                    <tr className='text-center'>
                                                        <th>
                                                            Name
                                                        </th>
                                                        <td>
                                                            {billableTime.length > 0 ? billableTime[0].name : userName}
                                                        </td>
                                                        <th>
                                                            Select Year
                                                        </th>
                                                        <td>
                                                            <select
                                                                className="form-select w-full"
                                                                value={selectedYear}
                                                                onChange={(e) => {
                                                                    setSelectedYear(parseInt(e.target.value));
                                                                    performancePoints(localStorage.getItem('user_id'), localStorage.getItem('role_id'), e.target.value);
                                                                }}
                                                            >
                                                                {Array.from(
                                                                    { length: 5 },
                                                                    (_, i) => new Date().getFullYear() - i
                                                                ).map(year => (
                                                                    <option key={year} value={year}>
                                                                        {year}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </td>
                                                    </tr>
                                            </thead>

                                        </table>
                                    </div>
                                    <div className='mt-3'>
                                        <div className="table-responsive">
                                            <table className="dashboard-table compact-table" style={{ tableLayout: "fixed" }}>
                                                <thead>
                                                    <tr>
                                                        <th>
                                                            Start Date
                                                        </th>
                                                        <th>
                                                            End Date
                                                        </th>                                                        
                                                        <th>
                                                            Billable Rate
                                                        </th>
                                                        <th>
                                                            Billable Time
                                                        </th>
                                                        <th>
                                                            Unbillable Time
                                                        </th>
                                                        <th>
                                                            Vacation/Stat Time
                                                        </th>
                                                        <th>
                                                            EOS Time
                                                        </th>
                                                        <th>
                                                            Sales auto
                                                        </th>
                                                        <th>
                                                            Sick Time
                                                        </th>
                                                        <th>
                                                            Total Hours
                                                        </th>
                                                        <th>
                                                            % Unbillable Time
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                        {payPeriods.length !== 0 ? payPeriods.map((period, index) => (
                                                            <tr 
                                                                className={`text-center cursor-pointer transition-colors duration-200
                                                                    ${roleID === '678b405eb4a77029c2ba7b7c' 
                                                                        ? (Math.floor(index / 2) % 2 === 0 ? 'bg-white' : 'bg-gray-50')
                                                                        : (index % 2 === 0 ? 'bg-white' : 'bg-gray-50')
                                                                    }
                                                                    ${selectedRow === index ? 'bg-blue-50' : 'hover:bg-gray-50'}`}
                                                                    
                                                                key={index}
                                                                onClick={() => {
                                                                    setSelectedRow(index === selectedRow ? null : index);
                                                                    console.log('Selected row:', period);
                                                                }}
                                                            >
                                                                <td>{new Date(period.payPeriodStartDate).toISOString().split('T')[0]}</td>
                                                                <td>{new Date(period.payPeriodEndDate).toISOString().split('T')[0]}</td>
                                                                <td>${period.billableRate}</td>
                                                                <td>{(period.billableTime).toFixed(2)}</td>
                                                                <td>{(period.unBillableTime).toFixed(2)}</td>
                                                                <td>{(period.vacatiomStatTime).toFixed(2)}</td>
                                                                <td>{(period.eosTime).toFixed(2)}</td>
                                                                <td>{(period.salesTime).toFixed(2)}</td>
                                                                <td>{(period.sickTime).toFixed(2)}</td>
                                                                <td>{(period.billableTime + period.unBillableTime + period.vacatiomStatTime + period.eosTime + period.salesTime + period.sickTime).toFixed(2)}</td>
                                                                <td>{(100 * period.unBillableTime/(period.billableTime + period.unBillableTime + period.vacatiomStatTime + period.eosTime + period.salesTime + period.sickTime)).toFixed(2) + "%"}</td>
                                                            </tr>
                                                        )) : (
                                                            <tr className='text-center bg-white'>
                                                                <td>$0</td>
                                                                <td>0</td>
                                                                <td>0</td>
                                                                <td>0</td>
                                                                <td>0</td>
                                                                <td>0</td>
                                                                <td>0</td>
                                                                <td>0</td>
                                                                <td>0</td>
                                                                <td>$0.00</td>
                                                                <td>$0.00</td>
                                                            </tr>
                                                        )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                </div>

                            </div>
                            {/* //!-----------0. MY BILLABLE VS UNBILLABLE TIME --------------------------- */}




                            {/* //*-----------3 MY CLIENT RATINGS --------------------------- */}

                            <div className='dashboard-card'>
                                <div className='dashboard-section-title' >
                                    <span>Monthly Client Ratings Bar Chart</span>
                                </div>
                                <div className='responsive-flex'>


                                    {/* //!-----------3.1 MY CLIENT RATINGS --------------------------- */}
                                    {/* Bar Chart Section */}
                                    <div className="mt-2 client-ratings-chart-section">
                                        <div className=''>
                                            {/* <div className='dashboard-section-title' style={{ fontSize: '1rem', borderBottom: 'none' }}>
                                                <span>Bar Chart</span>
                                            </div> */}
                                            <div className="chart-wrapper">
                                                <Chart type="bar" data={barChartData} options={barChartOptions} />
                                            </div>
                                        </div>
                                    </div>
                                    {/* //!-----------3.1 MY CLIENT RATINGS --------------------------- */}

                                    {/* //*-----------3.2 MY CLIENT RATINGS --------------------------- */}
                                    {/* Table Section */}
                                    <div header="MY CLIENT RATINGS" className='p-2 pt-0 mt-2 client-ratings-table-section'>
                                        <div className="table-responsive" style={{ height: '400px' }}>
                                            <table className="dashboard-table compact-table">
                                                <thead>
                                                    <tr>
                                                        <th>
                                                            <span>
                                                                Project
                                                            </span>
                                                        </th>
                                                        <th>
                                                            <span>
                                                                Client
                                                            </span>
                                                        </th>
                                                        <th>
                                                            <span>
                                                                Value
                                                            </span>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {monthlyClientRating.length > 1 && ( // Ensure there are at least 2 elements
                                                        <>
                                                            {/* Find the "Total" row once before mapping */}
                                                            {(() => {
                                                                const totalRow = monthlyClientRating.find(row => row.rowKey_0 === "Total");
                                                                return Object.keys(monthlyClientRating[0]).slice(2, 23).map((key, index) => {
                                                                    const projectName = monthlyClientRating[0][key]; // Full project name
                                                                    const clientName = projectName.split('(')[1]?.trim().replace(')', ''); // Extract client name

                                                                    // Get the total value for the current project from the totalRow
                                                                    const totalValue = totalRow ? totalRow[key] : '';

                                                                    return (
                                                                        <tr key={index} >
                                                                            <td>
                                                                                {projectName.split('(')[0].trim()} {/* Project Name without client */}
                                                                            </td>
                                                                            <td>
                                                                                {clientName || ''} {/* Client Name extracted from project name */}
                                                                            </td>
                                                                            <td>
                                                                                {totalValue !== undefined
                                                                                    ? formatValue(totalValue)
                                                                                    : ''}
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                });
                                                            })()}
                                                        </>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    {/* //!-----------3.2 MY CLIENT RATINGS --------------------------- */}
                                </div>
                            </div>
                            {/* //!-----------3 MY CLIENT RATINGS --------------------------- */}


                        </div>
                    )}

                </div>
            </form>

        </div>
    )
}

export default MainDashboard



